<template>
  <div>
    <Card title="Referral Data Click Banner">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <date-range-picker
                  ref="picker"
                  :timePicker="false"
                  :showDropdowns="false"
                  :max-date="maxDate"
                  v-model="dateRange"
                  :opens="'right'"
                  @update="onChangeDate"
                  :auto-apply="true"
                >
                  <template v-slot:input="picker" >
                    From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
              <div class="mr-2">
                <el-input placeholder="search" v-model="filter.q" @change="searchMember" ></el-input>
              </div>
            </div>
          </div>
          <data-tables-server ref="tableRating" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
            </el-table-column>
          </data-tables-server>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'ReferralDataBanner',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      titles: [{
        prop: {
          field: 'name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Email',
      }, {
        prop: {
          field: 'created_at',
        },
        label: 'Created Date',
      },],
      filter: {
        page: 1,
        per_page: 20,
        q: '',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        sortby: 'created_at',
        sortorder: 'desc',
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListReferralBanner(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('ReferralDataModule', ['listBanner']),
  },
  watch: {
    listBanner: {
      immediate: true,
      async handler(val) {
        if (val.data) {
          await this.refineData();
        }
      },
    },
  },
  methods: {
    ...mapActions('ReferralDataModule', ['requestListReferralBanner']),
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async searchMember() {
      this.filter.page = 1;
      await this.requestListReferralBanner(this.filterFormatUtc({}));
    },
    async resetMember() {
      this.$refs.tableRating.$refs.elTable.clearSort();
      this.filter.page = 1;
      this.filter.q = '';
      await this.requestListReferralBanner(this.filterFormatUtc({}));
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      const pageSize = queryInfo.pageSize;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order;
      if (typeof (sortorder) === 'undefined') {
        sortorder = 'desc';
      } else {
        sortorder = queryInfo.sort.order === 'ascending' ? 'asc' : 'desc';
      }
      if (typeof (sortby) === 'undefined') {
        sortby = 'created_at';
      }
      this.filter = Object.assign(this.filter, { page, sortby, sortorder, per_page: pageSize });
      await this.requestListReferralBanner(this.filterFormatUtc({}));
    },
    refineData() {
      this.data = this.listBanner.data.data.map((val) => {
        return { ...val,
          created_at: moment(val.created_at).format('YYYY-MM-DD HH:mm:ss'),
        };
      });
      this.total = this.listBanner.data.total;
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.searchMember();
    },
  },
  components: {
    VueCustomTooltip,
    DateRangePicker,
    Button,
    Card,
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}

</style>



// WEBPACK FOOTER //
// src/views/ReferralData/ReferralDataBanner.vue